export default __webpack_public_path__ + "static/coming-soon-1e1bba6b7b755bf53a3dba359bae5f9c.png";